import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { selectCurrentUser } from '../../store/modules/users/selectors';
import Tabs from '../tabs/TabsLink';
import { TabLinkService } from '../../services/TabLinkService/TabLinkService';
import { TabPages } from '../../services/TabLinkService/types';

type Props = {
  variant: TabPages;
};

const SideTabs = ({ variant }: Props) => {
  const { data: currentUser } = useSelector(selectCurrentUser);
  const { path, params: { id } } = useRouteMatch<{id: string}>();
  let tabs = TabLinkService.get(variant, { recordId: id, currentUser, path });
  tabs = id === 'new' ? [tabs[0]] : tabs;
  return (
    <Tabs tabs={tabs} />
  );
};

export default SideTabs;
